import { isAdmin } from '../../auth/roles';
import { createRoleRoute } from './createRoleRoute';

/**
 * Pathless layout under /admin: AdminRoute already admitted a STAFF user; this
 * narrows every pre-existing admin page to ADMIN roles. account_sales and
 * account_retoucher users get Forbidden here, not just a hidden menu item —
 * deep links included.
 */
const AdminOnlyRoute = createRoleRoute('AdminOnlyRoute', isAdmin, 'admin');

export default AdminOnlyRoute;
